<template>
  <div class="IssuesBody">
    <div v-for="(item, index) in loanIssues" :key="index">
      <div class="title">{{ item.title }}</div>
      <div class="content">{{ item.content }}</div>
    </div>
  </div>
</template>
<script>
export default {
  name: "LoanIssues",
  data() {
    return {
      loanIssues: [
        {
          title: "等额本息",
          content: "每月还款额度不变，其中月供本金每月增加，月供利息每月减少。",
        },
        {
          title: "等额本金",
          content: "每月还款额度递减，其中月供本金每月不变，月供利息每月减少。",
        },
        {
          title: "贷款年限",
          content:
            "贷款年限上限30年，其中贷款人年龄、房屋建筑年代对实际贷款年限均有影响，因各个银行政策不同，请以实际贷款银行为准。",
        },
        {
          title: "贷款成数",
          content:
            "贷款金额与房屋总价的比例，具体贷款成数因各地政策不同及购房套数不同而变化，请以当地购房政策为准。",
        },
        {
          title: "贷款利率",
          content:
            ' 自2019年10月8日起，新发放的商业住房贷款的贷款利率由"贷款基准利率"转换为"贷款市场报价利率(LPR)”。在LPR的基础上增加基点来确定最终的商贷利率；LPR每月20日(遇节假日顺延)报价一次，可在中国人民银行网站查询。 ',
        },
      ],
    };
  },
};
</script>
<style scoped>
.IssuesBody {
  height: 100vh;
  width: 750px;
  background-color: #fff;
  padding: 48px 36px;
}
.title {
  font-weight: 500;
  font-size: 36px;
  color: #222222;
  line-height: 50px;
  text-align: left;
  font-style: normal;
  margin-bottom: 12px;
}
.content {
  width: 676px;
  font-weight: 400;
  font-size: 28px;
  color: #222222;
  line-height: 40px;
  text-align: left;
  font-style: normal;
  display: flex;
  flex-wrap: wrap;
  margin-bottom: 48px;
}
</style>
